import React, { useEffect, useRef } from "react";
import Prism from "prismjs";
import "prismjs/components/prism-bash";
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-ruby";
import "prismjs/components/prism-markup-templating";
import "prismjs/components/prism-php";
import "prismjs/components/prism-python";
import "prismjs/components/prism-json";
import { copyText } from '@opendate-app/setlist';

const LANGUAGE_MAP = {
  shell: "bash",
  bash: "bash",
  curl: "bash",
  javascript: "javascript",
  nodejs: "javascript",
  ruby: "ruby",
  php: "php",
  python: "python",
  json: "json",
  text: "text",
};

const CodeBlock = ({ code, language = "text" }) => {
  const codeRef = useRef(null);
  const prismLanguage = LANGUAGE_MAP[language] || language;

  useEffect(() => {
    if (codeRef.current && prismLanguage !== "text" && Prism.languages[prismLanguage]) {
      Prism.highlightElement(codeRef.current);
    }
  }, [code, prismLanguage]);

  const handleCopy = () => { copyText(code); };

  return (
    <div className="api-docs-code-block">
      <button className="api-docs-copy-btn" onClick={handleCopy} title="Copy to clipboard">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
          <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
        </svg>
      </button>
      <pre>
        <code ref={codeRef} className={prismLanguage !== "text" ? `language-${prismLanguage}` : ""}>
          {code}
        </code>
      </pre>
    </div>
  );
};

export default CodeBlock;
